import {
  AxiosHttpClient,
  HttpClientOptions,
} from '@airship-platform/http-service';

const createHttpClient = (opts: HttpClientOptions) => new AxiosHttpClient(opts);

export { createHttpClient };
